import app from 'flarum/forum/app';
import extractText from 'flarum/common/utils/extractText';
export const statuses = ['NEW', 'QUOTED', 'PAYMENT_PENDING', 'PAID', 'IN_PROGRESS', 'COMPLETED', 'CANCELLED', 'REFUNDED'];
export const currencies = ['EUR', 'USD', 'BYN'];
export const defaultCurrency = 'EUR';
export const t = function (key, values) {
  if (values === void 0) {
    values = {};
  }
  return app.translator.trans('bsi-orders.lib.' + key, values);
};
export const text = function (key, values) {
  if (values === void 0) {
    values = {};
  }
  return extractText(t(key, values));
};
export const canManage = () => !!app.forum.attribute('bsiCanManage');
export const orderUrl = id => app.route('bsi.order', {
  id
});
export const record = resource => resource ? {
  ...resource.attributes,
  id: resource.id
} : null;
export const date = value => value ? new Intl.DateTimeFormat(app.data.locale === 'ru' ? 'ru-RU' : 'en-GB', {
  dateStyle: 'medium',
  timeStyle: 'short'
}).format(new Date(value)) : '—';
export const money = function (amount, currency) {
  if (currency === void 0) {
    currency = defaultCurrency;
  }
  return amount == null ? '—' : new Intl.NumberFormat(app.data.locale === 'ru' ? 'ru-RU' : 'en-GB', {
    style: 'currency',
    currency,
    currencyDisplay: 'code'
  }).format(amount / 100);
};
export const vehicle = order => [order.make, order.model, order.year].filter(Boolean).join(' ') || text('orders.vehicle_unknown');
export const fileSize = size => {
  const unit = size >= 1024 * 1024 ? ['mb', 1024 * 1024] : size >= 1024 ? ['kb', 1024] : ['bytes', 1];
  return new Intl.NumberFormat(app.data.locale === 'ru' ? 'ru-RU' : 'en-GB', {
    maximumFractionDigits: unit[1] === 1 ? 0 : 1
  }).format(size / unit[1]) + ' ' + text('files.' + unit[0]);
};
export function errorText(error) {
  const code = error?.response?.errors?.[0]?.code;
  if (code?.startsWith('bsi-orders.errors.')) return app.translator.trans(code.replace('bsi-orders.errors.', 'bsi-orders.lib.errors.'));
  if (error?.status === 401) return t('errors.unauthenticated');
  if (error?.status === 403) return t('errors.forbidden');
  if (error?.status === 404) return t('errors.order_not_found');
  if (error?.status === 413) return t('errors.file_too_large');
  if (error?.status === 422) return t('errors.invalid_input');
  return t('errors.server_error');
}
export function api(path, options) {
  if (options === void 0) {
    options = {};
  }
  return app.request({
    url: app.forum.attribute('apiUrl') + '/bsi' + path,
    errorHandler: () => {},
    ...options
  });
}
export function upload(path, _ref) {
  let {
    onProgress,
    ...options
  } = _ref;
  return api(path, {
    method: 'POST',
    ...options,
    config(xhr) {
      xhr.upload.addEventListener('progress', event => {
        onProgress?.(event.lengthComputable && event.total > 0 ? Math.min(100, Math.round(event.loaded * 100 / event.total)) : null);
        m.redraw();
      });
      xhr.upload.addEventListener('load', () => {
        onProgress?.(100);
        m.redraw();
      });
    }
  });
}